export default {
  cursor_x: 0,
  is_super_admin: false,
}
